'use client';

import {createFlagsmithInstance} from 'flagsmith/isomorphic';
import {FlagsmithProvider} from 'flagsmith/react';
import type {IState} from 'flagsmith/types';
import {useRef, useEffect} from 'react';
import type {ReactElement} from 'react';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const FlagsProvider = ({children, flagsmithState}: {children: React.ReactNode; flagsmithState?: IState}) => {
  const flagsmithRef = useRef(createFlagsmithInstance());

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const hostname = window.location.hostname;
      flagsmithRef.current.setTrait(`domain`, hostname);
    }
  }, []);

  return (
    <FlagsmithProvider
      flagsmith={flagsmithRef.current}
      serverState={flagsmithState}
      options={{
        cacheFlags: true,
        cacheOptions: {
          ttl: FIVE_MINUTES_MS,
          skipAPI: false,
          loadStale: true,
        },
      }}
    >
      {children as ReactElement<any>}
    </FlagsmithProvider>
  );
};
